import { useCallback, useEffect } from "react";

import { MESSAGE } from "services/wearables/WearablesService";

const useModelLoaded = (callback: () => void): void => {
  const onMessage = useCallback(
    (e: MessageEvent) => {
      if (e?.data?.name !== MESSAGE.MODEL_LOADED) return;
      callback && callback();
    },
    [callback],
  );
  useEffect(() => {
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, [onMessage]);
};

export default useModelLoaded;
